import React, {Component} from 'react';

class HeaderBackground extends Component {

    render() {
        return (
            <div className="header-bg">
                <div className="header-image" data-autoplay="8">
                    <div className="image-layer" style={{backgroundImage: `url(${this.props.url})`}}></div>
                </div>
            </div>
        )
    }
}

export default HeaderBackground



// WEBPACK FOOTER //
// ./src/components/header/HeaderBackground.js